export const naturalSort = (arr: any[], prop: string) =>
    arr.sort((a, b) => {
        const propA = (a[prop] || "").toLowerCase();
        const propB = (b[prop] || "").toLowerCase();

        return propA.localeCompare(propB, undefined, {
            numeric: true,
        });
    });
